import routerOptions0 from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.15.0_db0@0.2.1_drizzle-orm@0.33.0_rollup@4.29.1_typescript@5.7.2_vite@6.0.6/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}